const DetailType=()=>{

}
export default DetailType